import { useEffect, useState } from 'react';
import { Button, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Modal, Paper, Select, Stack, TextField, Typography, FormGroup } from '@mui/material';
// import { COUNTRIES, VALID_HOSPITALS } from '../../util/Constants';
import { COUNTRIES } from '../../util/Constants';
import axios from '../../util/Axios';

const formControlStyle = { width: '100%', marginBottom: '16px' };

export function EditDoctor({ editDoctorOpen, handleEditClose, doctorName, setDoctorName, doctorPhone, setDoctorPhone, doctorHospital, setDoctorHospital, changeDoctor, doctorCountry, setDoctorCountry, doctorEnabled, setDoctorEnabled, doctorAdmin, setDoctorAdmin }) {

  const [hospitals, setHospitals] = useState([]);

  useEffect(() => {
    axios.get('/hospitals')
      .then(response => {
        setHospitals(response.data);
      });
  }, []);

  return (
    <Modal open={editDoctorOpen} onClose={handleEditClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Paper
        sx={{
          padding: '16px',
          position: 'absolute',
          minWidth: '550px',

          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          component="h3"
          sx={{
            fontSize: '1.5em',
            textAlign: 'center',
            marginBottom: '8px',
          }}
        >
          Edit Doctor
        </Typography>
        <TextField sx={formControlStyle} variant="standard" label="Name" value={doctorName} onChange={(event) => setDoctorName(event.target.value)} />
        <TextField sx={formControlStyle} variant="standard" label="Phone" value={doctorPhone} onChange={(event) => setDoctorPhone(event.target.value)} />
        <FormControl sx={formControlStyle} variant="standard">
          <InputLabel>Hospital</InputLabel>
          <Select value={doctorHospital} onChange={(event) => setDoctorHospital(event.target.value)}>
            {hospitals.map((hospital) => (
              <MenuItem key={hospital.id} value={hospital.name}>
                {hospital.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={formControlStyle} variant="standard">
          <InputLabel>Country</InputLabel>
          <Select value={doctorCountry} onChange={(event) => setDoctorCountry(event.target.value)}>
            {COUNTRIES.map(({ name, code }) => (
              <MenuItem key={name} value={code}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormGroup sx={{ alignSelf: 'flex-start' }}>
          <FormControlLabel control={<Checkbox onChange={(event) => setDoctorEnabled(event.target.checked)} checked={doctorEnabled} />} label="Enabled" />
          <FormControlLabel control={<Checkbox onChange={(event) => setDoctorAdmin(event.target.checked)} checked={doctorAdmin} />} label="Admin" />
        </FormGroup>
        <Stack direction="row" justifyContent="flex-end">
          <Button onClick={handleEditClose}>Cancel</Button>
          <Button variant="contained" onClick={() => changeDoctor()}>
            Save Changes
          </Button>
        </Stack>
      </Paper>
    </Modal>
  );
}
